import { concat } from 'lodash'
import { http, id, pagination } from 'utils'
import { SET_ITEMS, ADD_ITEMS, SET_META } from 'vx/mutations'
import { RESET_INVOICE, UPDATE_INVOICE } from '../../mutations'

export default {
  namespaced: true,

  state: {
    invoices: [],
    invoice: {}
  },

  actions: {
    async getInvoiceRunItems ({ commit, state }, { invoiceRunId, params = {} } = {}) {
      if (state.meta) {
        if (pagination(state.meta)) {
          return Promise.reject(new Error('No more results.'))
        }

        params.page = state.meta.current_page + 1
      }

      const response = await http.get(`invoice-runs/${id(invoiceRunId)}/invoice-run-items`, { params })

      commit(ADD_ITEMS, response.data.data)
      commit(SET_META, response.data.meta)

      return response
    },

    resetInvoices ({ commit }) {
      commit(SET_ITEMS, [])
      commit(SET_META, null)
    },

    async getInvoice ({ commit }, { invoiceRunId, invoiceId, params = {} } = {}) {
      commit(RESET_INVOICE)
      const response = await http.get(`invoice-runs/${id(invoiceRunId)}/invoice-run-items/${id(invoiceId)}`)

      commit(UPDATE_INVOICE, response.data.data)

      return response
    },

    async updateInvoice ({ dispatch }, { invoiceRunId, invoiceId, invoice }) {
      const response = await http.put(`invoice-runs/${id(invoiceRunId)}/invoice-run-items/${invoice.id}`, invoice)

      dispatch('setUpdatedInvoice', response.data.data)

      return response.data.meta
    },

    async deleteInvoice ({ commit }, { invoiceRunId, invoiceId }) {
      try {
        await http.delete(`invoice-runs/${id(invoiceRunId)}/invoice-run-items/${id(invoiceId)}`)
      } catch (err) {
        throw err
      }
    },

    async storeManualCharge ({ commit, state: { invoices, invoice } }, { invoiceRunId, payload }) {
      const response = await http.post(`invoice-runs/${invoiceRunId}/manual-charge`, payload)

      commit(UPDATE_INVOICE, response.data.data)

      invoices.push(response.data.data)

      commit(SET_ITEMS, invoices)
      return response
    },

    setUpdatedInvoice ({ commit }, invoice) {
      commit(UPDATE_INVOICE, invoice)
    },

    updateDeletedInvoice ({ commit }, invoice) {
      commit(UPDATE_INVOICE, {})
    },

    async resetInvoice ({ commit, state: { invoices, invoice } }) {
      commit(UPDATE_INVOICE, {})
    }
  },

  mutations: {
    [ADD_ITEMS] (state, items) {
      state.invoices = concat(state.invoices, items)
    },
    [SET_META] (state, meta) {
      state.meta = meta
    },
    [SET_ITEMS] (state, items) {
      state.invoices = items
    },
    [RESET_INVOICE] (state, id) {
      state.invoice = {}
    },
    [UPDATE_INVOICE] (state, invoice) {
      state.invoice = invoice
    }
  }
}
